import type { IdentityReason } from "@/lib/access/respondent/needs-identity";

/**
 * How long a custom sign-in code in `nowadays.users_otp` stays valid. The codes
 * are six digits, so a short life plus one attempt per code keeps guessing out of
 * reach (ENG-726: a verified code links the login to the person who owns the
 * address).
 */
export const CUSTOM_OTP_TTL_MS = 15 * 60 * 1000;

/** How many digits a sign-in code has. */
export const OTP_LENGTH = 6;

/** How long the sign-in form waits before it lets the visitor ask for a new code. */
export const OTP_RESEND_COOLDOWN_SECONDS = 60;

/** How often the resend countdown ticks down by one second. */
export const OTP_RESEND_TICK_MS = 1000;

/** The Route Handler that checks a sign-in code and sets the session cookies. */
export const VERIFY_OTP_PATH = "/api/auth/verify-otp";

/**
 * The one line the sign-in page shows under its callout, per reason a form asks people to sign in
 * (the `reason` param the respondent decision puts on the redirect). Unknown values show nothing.
 */
export const IDENTITY_REASON_LINES: Record<IdentityReason, string> = {
  one_per_person: "This form allows one response per person, so we need to know who you are.",
  invited: "This form is for people on the invite list, so we need to know who you are.",
  login: "This form asks everyone to sign in, so we need to know who you are.",
  sso: "This form is for people at one organization, so we need to know who you are.",
  domain: "This form is for people with certain work emails, so we need to know who you are.",
};
